import React, { createContext, useContext, useEffect, useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const SESSION_KEY = 'fingerprint';

interface FingerprintContextType {
    fingerprint: string | null;
    loading: boolean;
}

const FingerprintContext = createContext<FingerprintContextType>({
    fingerprint: null,
    loading: true,
});

export const useFingerprint = () => useContext(FingerprintContext);

export const FingerprintProvider = ({ children }: any) => {
    const existing = sessionStorage.getItem(SESSION_KEY);
    const [fingerprint, setFingerprint] = useState<string | null>(existing);
    const [loading, setLoading] = useState(!existing);

    useEffect(() => {
        if (existing) return;

        const loadFingerprint = async () => {
            try {
                const fp = await FingerprintJS.load();
                const result = await fp.get();
                sessionStorage.setItem(SESSION_KEY, result.visitorId);
                setFingerprint(result.visitorId);
            } catch (error) {
                console.error("Fingerprint error:", error);
            } finally {
                setLoading(false);
            }
        };

        loadFingerprint();
    }, []);

    return (
        <FingerprintContext.Provider value={{ fingerprint, loading }}>
            {children}
        </FingerprintContext.Provider>
    );
};